if(!customElements.get('swiper-slider')) {
  customElements.define('swiper-slider', class SwiperSlider extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      this.initSlider();
    }
  
    get slidesQuantity () {
      return Number(this.dataset.slides) + 0.2;
    }
  
    get pagiantionType () {
      return this.dataset.paginationType;
    }
  
    get showNavigation() {
      return this.dataset.navigation === 'true' ? true : false;
    }

    get autoPlay() {
      return this.dataset.autoplay === 'true' ? true : false;
    }

    get autoPlayDelay() {
      return this.dataset.autoplayDelay ? Number(this.dataset.autoplayDelay) : 5000;
    }

    get loop() {
      return this.dataset.loop === 'true' ? true : false;
    }

    get slidesPerViewMobile() {
      return this.dataset.slidesPerViewMobile ? Number(this.dataset.slidesPerViewMobile) : 1.2;
    }

    get grabCursor() {
      return this.dataset.grabCursor === 'true' ? true : false; // default false
    }

    get centeredSlides() {
      return this.dataset.centeredSlides === 'true' ? true : false; // default false
    }

    get cssMode() {
      return this.dataset.cssMode === 'false' ? false : true; // default true
    }

    get autoHeight() {
      return this.dataset.autoHeight === 'true' ? true : false;
    }

    get fullWidthSlider() {
      return this.dataset.fullWidthSlider === 'true' ? true : false;
    }
  
    initSlider() {
      const slider = this.querySelector(`.swiper`);
      if (slider) {
        const options = {
          grabCursor: this.grabCursor,
          centeredSlides: this.centeredSlides,
          slidesPerView: this.slidesPerViewMobile,
          slidesPerMove: 1,
          spaceBetween: 20,
          cssMode: this.cssMode,
          autoHeight: this.autoHeight,
          pagination: {
            el: `#${this.id} .js-custom-pagination`,
            type: this.pagiantionType,
            clickable: true
          },
          a11y: {
            wrapperLiveRegion: false
          },
        }

        if (!this.fullWidthSlider) {
          options.breakpoints = {
            600: {
              slidesPerView: 2.2,
            },
            700: {
              slidesPerView: 2.7,
            },
            980: {
              slidesPerView: this.slidesQuantity - 1,
              spaceBetween: 30,
            },
            1150: {
              slidesPerView: this.slidesQuantity,
              spaceBetween: 30,
            }
          }
        }

        if (this.autoPlay) {
          options.autoplay = {
            delay: this.autoPlayDelay,
          };
        }

        if (this.loop) {
          options.loop = true;
        }
    
        if(this.showNavigation) {
          options.navigation = {
            nextEl: `#${this.id} .js-custom-next`,
            prevEl: `#${this.id} .js-custom-prev`,
          }
        }
        const swiper = new Swiper(slider, options);

        const wrapper = slider.querySelector('.swiper-wrapper');
        if (wrapper && wrapper?.hasAttribute('aria-live')) {
          wrapper.removeAttribute('aria-live');
        }
        this._setupAccessibility(slider, swiper);

        if (this.slidesQuantity < 4 && window.innerWidth >= 980 && !this.fullWidthSlider) {
          swiper.destroy();
        }
      }
    }

    _setupAccessibility(slider, swiper) {
      const prevBtn = slider.querySelector('.swiper-button-prev');
      const nextBtn = slider.querySelector('.swiper-button-next');
      const loopEnabled = this.loop;

      [prevBtn, nextBtn].forEach((btn, index) => {
        if (btn) {
          btn.setAttribute('tabindex', '0');
          btn.setAttribute('role', 'button');
          btn.setAttribute('aria-label', index === 0 ? 'Previous slide' : 'Next slide');
          
          btn.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              index === 0 ? swiper.slidePrev() : swiper.slideNext();
            }
          });
          btn.addEventListener('keyup', (e) => {
            if (e.key === ' ') {
              e.preventDefault();
              index === 0 ? swiper.slidePrev() : swiper.slideNext();
            }
          });
        }
      });

      this.addEventListener('focusin', () => {
        if (this.autoPlay && swiper.autoplay) {
          swiper.autoplay.stop();
        }
        
        if (loopEnabled && swiper.params.loop) {
          swiper.loopDestroy();
          swiper.params.loop = false;
          swiper.update();
        }
      });

      this.addEventListener('focusout', (e) => {
        setTimeout(() => {
          if (!this.contains(document.activeElement)) {
            if (loopEnabled && !swiper.params.loop) {
              swiper.params.loop = true;
              swiper.loopCreate();
              swiper.update();
            }
            
            if (this.autoPlay && swiper.autoplay) {
              swiper.autoplay.start();
            }
          }
        }, 0);
      });
    }
  })
}
